/**
 * Ugly hacks for making packages available globally.
 */

import Jquery from 'jquery';
window.$ = Jquery;
window.jQuery = Jquery;
export default jQuery;



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/workarounds/workarounds.js